import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  Image,
  ItemContainer,
  ItemSelected,
  Text,
  TextItemSelected,
} from './styles';

class SidebarItem extends Component {
  onItemClicked = () => {
    const { onSidebarItemClicked } = this.props;
    onSidebarItemClicked();
  }

  render() {
    const {
      active, image, label, imageSelected, dataName,
    } = this.props;

    return (
      <ItemContainer onClick={this.onItemClicked} data-sidebar-item={`${dataName}`} data-sidebar-active={`${active}`}>
        <Image src={`../../../../../images/${image}`} visible={!active} />
        <Image src={`../../../../../images/${imageSelected}`} visible={active} />
        {!active && (
          <Text>{label}</Text>
        )}
        {active && (
          <>
            <TextItemSelected>{label}</TextItemSelected>
            <ItemSelected />
          </>
        )}
      </ItemContainer>
    );
  }
}

SidebarItem.defaultProps = {
  dataName: '',
};

SidebarItem.propTypes = {
  active: PropTypes.bool.isRequired,
  image: PropTypes.string.isRequired,
  imageSelected: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onSidebarItemClicked: PropTypes.func.isRequired,
  dataName: PropTypes.string,
};

export default SidebarItem;
